import type { Language } from '@coolblue-development/constants';
import type { InstallationServiceData } from '@coolblue-development/next-installation-services';
import type { Product } from '@features/product/typings';
import type { PropositionTypes } from '@features/product-page/typings';
import { SecondChanceProduct } from '@features/second-chance/typings';

export enum OrderBlockType {
  SUMMARY = 'summary',
  DEFAULT = 'default',
  OUT_OF_STOCK = 'outOfStock'
}

export type OrderBlockProps = {
  product: Product;
  services?: InstallationServiceData[] | null;
  propositions?: PropositionTypes;
  language: Language;
  loadProductTradeIn?: boolean;
  isLeasePage?: boolean;
  isMandatoryPostalCodeSplitTestInVariation: boolean;
  shouldDisableAddToCart: boolean;
  orderBlockType?: OrderBlockType; // to determine the type of the orderBlock
};

export type SecondChanceOrderBlockProps = {
  product: SecondChanceProduct;
  services?: InstallationServiceData[] | null;
  propositions?: PropositionTypes;
  language: Language;
  loadProductTradeIn?: boolean;
  isLeasePage?: boolean;
  isMandatoryPostalCodeSplitTestInVariation: boolean;
  shouldDisableAddToCart: boolean;
  orderBlockType?: OrderBlockType; // to determine the type of the orderBlock
};
